<template>
  <div class="discover-state compact">
    <i class="el-icon-files" />
    <strong>{{ text }}</strong>
    <p v-if="description">{{ description }}</p>
  </div>
</template>

<script>
export default {
  name: "DiscoverEmptyState",
  props: {
    text: { type: String, required: true },
    description: { type: String, default: "" }
  }
}
</script>

